<script>
import api from '@/helpers/api'
export default {
  name: 'form-card.generic',
  props: {
    product: { type: Object, required: true }
  },
  data: () => ({
    files: [],
    hovered: true
  }),
  mounted () {
    //this.fetchProductFiles()
  },
  methods: {
    onHoverHandler (hover) {
      //this.hovered = hover
    },
    async fetchProductFiles () {
      let { items } = await api.productFiles.fetchPage({
        page: 1,
        pageSize: 5,
        filters: [
          { product_id: { _eq: this.product.id } },
          { file: { file_content_type: { _ilike: 'image/%' } } }
        ]
      })

      this.files = [
        ...items.map(f => ({
          ...f.file,
          name: f.file.file_name,
          size: f.file.file_size,
          type: f.file.file_content_type
        }))
      ]
    }
  }
}
</script>
<template>
  <b-card no-body class="product--card shadow-none">
    <b-card-body class="p-1 d-flex align-items-center justify-content-between">
      <b-row
        no-gutters
        align-v="start"
        align-h="start"
        class="flex-column w-100 p-2"
      >
        <div class="d-flex align-items-center justify-content-start">
          <p
            class="text-uppercase text-muted m-0 pointer"
            v-on:click="
              $router.push({
                name: 'sales.shop.product',
                params: { id: product.id }
              })
            "
          >
            {{ product.short_description }}
          </p>
          <i
            class="bx bxs-star text-primary font-size-14 align-content-center mx-2"
            v-if="product.is_favorite"
          />
          <i
            class="bx bx-star text-primary font-size-14 align-content-center mx-2"
            v-else
          />
        </div>

        <small class="my-1 text-muted text-wrap w-75">
          {{ product.extra_description }}
        </small>
      </b-row>

      <app-add-to-cart-form
        class="mx-2"
        :product-id="product.id"
        :hideQuantity="true"
        :product="product"
      />
    </b-card-body>
  </b-card>
</template>

<style lang="scss">
.product--card {
  position: relative;

  .favorite {
    position: absolute;
    top: 0;
    right: 0;
    padding: 10px;
  }
}
</style>
